"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CropTouch = (function () {
    function CropTouch(x, y, id) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        if (id === void 0) { id = 0; }
        this.id = id;
        this.x = x;
        this.y = y;
    }
    return CropTouch;
}());
exports.CropTouch = CropTouch;
//# sourceMappingURL=cropTouch.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-img-cropper/src/model/cropTouch.js
// module id = 1126
// module chunks = 323